module.exports = __webpack_public_path__ + "img/print-config-icon.b9bbd056.svg";